
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#020303"}},[_c('path',{attrs:{"d":"M60.9 18.914H11.1h49.8z","stroke-linejoin":"bevel"}}),_c('path',{attrs:{"d":"M60.9 18.614v32.9H11.1v-32.6"}}),_c('path',{attrs:{"stroke-linejoin":"bevel","d":"M11.2 19.214l22.2 17.7 27.5-18"}})]),_c('path',{attrs:{"fill":"none","stroke":"#020303","stroke-linejoin":"bevel","d":"M26.9 12.1v15.5M31.1 5v20M36 13v15.4"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0bdbf6","d":"M45.7 60l5.6.2.7-18.9-5.6-.2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0bdbf6","d":"M49.4 35.9l-10.1 9.3 2.8 3.1 10.1-9.4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0bdbf6","d":"M58.9 46l-9.5-10.1-3 2.8 9.5 10.1z"}})])
          )
        }
      }
    